import { Observable } from 'rxjs';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';

import { selectOrganization, selectUserLocations } from 'entities/user/selectors';
import { STORE as STORE_USER } from 'entities/user/constants';
import LocationApi from 'entities/location/api';

import { initSuccessAction, initFailedAction, InitAction } from './actions';
import { INIT } from './constants';

const init = (action$: ActionsObservable<InitAction>, store: Store) =>
  action$.ofType(INIT, STORE_USER).mergeMap(() => {
    const state = store.getState();
    const organization = selectOrganization(state);
    if (!organization) {
      return [];
    }

    const actions = [];

    const locations = selectUserLocations(state);

    if (locations.size === 0) {
      actions.push(LocationApi.fetchAll());
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
